import {
  getUserConfigFlags,
  getUserDetails,
  getSupportInfo,
  getProductValidationValues
}
  from 'user/selectors';
import {
  processUserConfigFlags,
  processUserDetails,
  processSupportInfo,
  processProductValidationValues
} from 'user/processors';
import {fetchUserConfigFlags, fetchUserDetails, fetchSupportInfo, fetchProductValidationValues} from 'user/loaders';

import { getActiveUserId } from 'current/selectors';
import { isEmpty } from 'lodash';

export const findUserConfigFlags = ({ dispatch, getState }) => {
  return Promise.resolve() // force a thenable wrapper
  .then( () => {
    const state = getState();
    const flags = getUserConfigFlags(state);
    if( !isEmpty(flags) ) {
      return Promise.resolve(flags);
    }

    const userId = getActiveUserId(state);
    return fetchUserConfigFlags({ userId })
    .then( (rawFlags) => processUserConfigFlags({ dispatch, getState, rawFlags }) );
  });
};

const _callFetchProductValidationValues = ({ dispatch, getState, accountCountry, unitsOfMeasureTemplate }) =>
  fetchProductValidationValues({ accountCountry })
  .then( rawProductValidationValues =>
    processProductValidationValues({ dispatch, getState, rawProductValidationValues, unitsOfMeasureTemplate })
  );

const _callFetchSupportInfo = ({ dispatch }) => {
  return Promise.resolve()
  .then( () => fetchSupportInfo() )
  .then( rawSupportInfo => processSupportInfo({ dispatch, rawSupportInfo}) );
};

const _callFetchUserDetails = ({ dispatch, getState, userId }) => {
  return Promise.resolve()
  .then( () => fetchUserDetails({ userId }) )
  .then( rawUserDetails => {
    return processUserDetails({ dispatch, getState, rawUserDetails });
  });
};

export const findUserDetails = ({ dispatch, getState, userId }) => {
  return Promise.resolve()
  .then( () => {
    const state = getState();
    const userDetails = getUserDetails(state);
    if( !isEmpty(userDetails) ) {
      return userDetails;
    }
    return _callFetchUserDetails({ dispatch, getState, userId })
    .then( () => {
      return getUserDetails(getState()); // get refreshed state, leave any fails to caller
    });
  });
};

export const findSupportInfo = ({ dispatch, getState }) => {
  return Promise.resolve()
  .then( () => {
    return _callFetchSupportInfo({ dispatch })
    .then( () => getSupportInfo(getState()) );
  });
};

export const findProductValidationValues = ({ dispatch, getState, accountCountry, unitsOfMeasureTemplate }) =>
  _callFetchProductValidationValues({ dispatch, getState, accountCountry, unitsOfMeasureTemplate })
  .then( () => getProductValidationValues(getState()));
